import { ReactElement } from 'react';
import { FormDesc, FormTitle } from './SignupForm.styled';
import { useCommonTranslation } from '../../../../hooks/i18n/useCommonTranslation';
import {
  SITE_SELECT_SEARCH_MIN_LENGTH,
  SiteSelect,
} from '../SiteSelect/SiteSelect';
import { SignupFormValues } from '../../../../types/users';
import { UseFormSetValue } from 'react-hook-form';

interface Props {
  setValue: UseFormSetValue<SignupFormValues>;
}

export const SignupStepHospitalSelect = ({ setValue }: Props): ReactElement => {
  const { t } = useCommonTranslation();

  return (
    <>
      <FormTitle>{t('select-hospital')}</FormTitle>
      <FormDesc
        style={{
          fontSize: 'var(--h4)',
        }}
      >
        {t('sites-hospital-select-title', {
          searchMinLength: SITE_SELECT_SEARCH_MIN_LENGTH,
        })}
      </FormDesc>
      <SiteSelect
        onSiteSelect={(site) => setValue('active_site_id', site.id)}
      />
    </>
  );
};
